/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const catalogEntryListCompareCollectorPriceDescSX: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	lineHeight: 1.25,
};
